import * as angular from 'angular';

import { timeagoFilter } from './timeago.filter';

export const timeagoModule = angular.module('timeago', [])
	.filter('timeago', timeagoFilter)
	.name;
